/**
 * パスワードのチェックを行う関数
 * @param password {string} - チェックするパスワード
 * @return {boolean} - パスワードが条件を満たしている場合は true、そうでない場合は false
 */
export function checkPassword(password: string) {
  // 英字 + 数字 を含む7文字以上のパスワードチェック
  // 記号は!@#$%^&*()_+-=[]{}| が利用可能
  const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+\-=[\]{}|]{7,}$/;
  return passwordRegex.test(password);
}

export function checkEmail(email: string | null | undefined) {
  // メールアドレスの正規表現
  const regex = /^(?!.*\.\.)(?!.*\.@)([\p{L}\p{N}!#$%&'*+/=?^_`{|}~-]+(?:\.[\p{L}\p{N}!#$%&'*+/=?^_`{|}~-]+)*)@([\p{L}\p{N}](?:[\p{L}\p{N}-]*[\p{L}\p{N}])?(?:\.[\p{L}\p{N}](?:[\p{L}\p{N}-]*[\p{L}\p{N}])?)*)\.[\p{L}]{1,}$/u;
  if (email === null || email === undefined || email.length === 0 || email.length > 254) {
    return false;
  }
  if (!regex.test(email)) {
    return false;
  }
  return email.split('@')[0].length <= 64;
}
